import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

function Header({ isOpenMenu, toggleMenu }) {
  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="header-container__logo" />
          <nav className="header-container__menu">
            <ul className="header-container__menu-list">
              <li>
                <a className="header-container__link" href="#skills">
                  Чему вы научитесь
                </a>
              </li>
              <li>
                <a className="header-container__link" href="#description">
                  Процесс обучения
                </a>
              </li>
              <li>
                <a className="header-container__link" href="#price">
                  Стоимость
                </a>
              </li>
              <li>
                <a className="header-container__link" href="#address">
                  Контакты
                </a>
              </li>
              <li>
                <a className="header-container__link" href="#teacher">
                  Кто вас обучает
                </a>
              </li>
            </ul>
          </nav>

          <ul className="header__link-list">
            <li>
              <Link className="header__link" to="/sign-up">
                Регистрация
              </Link>
            </li>
            <li>
              <Link className="header__link header__link_out" to="/sign-in">
                Войти
              </Link>
            </li>
          </ul>

          <button
            className="burger"
            onClick={toggleMenu}
            aria-label={isOpenMenu ? "Close menu" : "Open menu"}
          >
            {isOpenMenu ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>
    </>
  );
}

export default Header;
